import { createReducer } from 'src/helpers/reducer';
import type { IBlockedRemoval, IScopeCombinationsResponse, ParsedErrorMap } from '../sharedTypes';
import actionTypes from './actionTypes';
import type { IEditAgencyContractState, ISubmitResult } from './types';

const initState: IEditAgencyContractState = {
  combinations: [],
  combinationsMeta: null,
  isLoadingCombinations: false,
  combinationsFailed: false,
  isSubmitting: false,
  parsedErrors: {},
  blockedRemovals: [],
  submitResult: null,
};

function onCombinationsSuccess(
  state: IEditAgencyContractState,
  { payload }: { payload: { response: IScopeCombinationsResponse } },
): IEditAgencyContractState {
  const { records, ...meta } = payload.response;

  return {
    ...state,
    isLoadingCombinations: false,
    combinationsFailed: false,
    combinations: records,
    combinationsMeta: meta,
  };
}

function onSubmitFailed(
  state: IEditAgencyContractState,
  { payload }: { payload: { parsedErrors: ParsedErrorMap; blockedRemovals: IBlockedRemoval[] } },
): IEditAgencyContractState {
  return {
    ...state,
    isSubmitting: false,
    parsedErrors: payload.parsedErrors,
    blockedRemovals: payload.blockedRemovals,
  };
}

export default createReducer(initState, {
  [actionTypes.LOAD_COMBINATIONS_REQUEST]: (state: IEditAgencyContractState) => ({
    ...state,
    isLoadingCombinations: true,
    combinationsFailed: false,
  }),
  [actionTypes.LOAD_COMBINATIONS_SUCCESS]: onCombinationsSuccess,
  [actionTypes.LOAD_COMBINATIONS_ERROR]: (state: IEditAgencyContractState) => ({
    ...state,
    isLoadingCombinations: false,
    combinationsFailed: true,
    // A stale priced set under a new engine or unit selection would be read as this selection's
    // prices, so it is dropped rather than left on screen.
    combinations: [],
    combinationsMeta: null,
  }),
  [actionTypes.CLEAR_COMBINATIONS]: (state: IEditAgencyContractState) => ({
    ...state,
    isLoadingCombinations: false,
    combinationsFailed: false,
    combinations: [],
    combinationsMeta: null,
  }),
  [actionTypes.SUBMIT_REQUEST]: (state: IEditAgencyContractState) => ({
    ...state,
    isSubmitting: true,
    parsedErrors: {},
    blockedRemovals: [],
  }),
  [actionTypes.SUBMIT_SUCCESS]: (
    state: IEditAgencyContractState,
    { payload }: { payload: { result: ISubmitResult } },
  ) => ({ ...state, isSubmitting: false, submitResult: payload.result }),
  [actionTypes.SUBMIT_FAILED]: onSubmitFailed,
  [actionTypes.CLEAR_SUBMIT_ERRORS]: (state: IEditAgencyContractState) => ({
    ...state,
    parsedErrors: {},
    blockedRemovals: [],
  }),
  [actionTypes.CLEAR_STORE]: () => initState,
});
